<template>
    <div>
        <el-dialog title="订单审核" :visible.sync="dialogVisible" width="25%" @close="onCancel">
            <el-form ref="addForm" :model="addForm" label-width="120px" :rules="rules">
                <el-form-item label="审核状态 :" prop="approveStatus">
                    <el-select style="width: 100%" v-model="addForm.approveStatus" @change="changeCollectType">
                        <el-option v-for="item in approveList" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item v-if="approveType == '2'" label="原因 :" prop="remark">
                    <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" v-model="addForm.remark"></el-input>
                </el-form-item>
            </el-form>

            <div class="dialog-footer tr mt-30">
                <el-button @click="onCancel">取 消</el-button>
                <el-button type="primary" @click="onSubmit">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            addForm: {
                approveStatus: '',
                remark: ''
            },
            rules: {
                approveStatus: [
                    { required: true, message: '审批状态不能为空', trigger: 'blur' }
                ],
                remark: [
                    { required: true, message: '原因不能为空', trigger: 'blur' }
                ],
            },
            orderId: '',
            approveType: '',
            approveList: [{ value: '0', label: '待审批' }, { value: '1', label: '已通过' }, { value: '2', label: '已拒绝' }],
            dialogVisible: false,
        }
    },

    methods: {
        init(id) {
            this.orderId = id
            this.dialogVisible = true
        },

        changeCollectType(type) {
            this.approveType = type
        },

        onCancel() {
            this.$refs['addForm'].resetFields()
            this.dialogVisible = false
        },

        onSubmit() {
            this.$refs['addForm'].validate((valid) => {
                if (valid) {
                    this.$api.appointSetting.approveTeamAppoint({ id: this.orderId, ...this.addForm }).then(res => {
                        if (res.code == 200) {
                            this.$message.success(res.message || '操作成功')
                            this.onCancel()
                            this.$emit('refresh')
                        } else {
                            this.$message.error(res.message || '系统异常')
                        }
                    })
                }
            })
        }
    }
}
</script>

<style></style>